<template>
    <div class="page_content stream_progress_view" aria-label="Stream Progress view content page">
      <div class="row page-heading">
        <div class="col-7 input module_heading" role="heading" aria-level="1">
          <span class="module_icon icon-stream"></span>
		  <label class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="stream.title"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{stream.title}}</label>
        </div>
        <div class="col-5 right-container">
		   <stream-header :uuid="uuid" active="category"></stream-header>
        </div>
      </div>
	  <div class="page-content">
		    <stream-menu :uuid="uuid" active="progress"></stream-menu>
			<div id="creditProgressPopup" class="credit-progress-popup"></div>
			<div class="col-11 dasboard-left-section" v-if="isProgramGuideAvailable">
				<div class="course-description col-12" style="height: 100%;">
					<div class="row dashboard-row">

					  <div class="credit-completion-section" :class="showDegreeProgress ? 'col-xl-9 col-lg-8 col-md-8 col-sm-12' : 'col-xl-12 col-lg-12 col-md-12 col-sm-12'">
						<div class="card ace_sec" :aria-label="creditLabel + ' Progress Section'">
							<div class="card-header">
								<span class="icon icon-meter"></span>
								<span class="label ace_sec_hd" :aria-label="'Program Progress'">Program Progress</span>

								<div class="more-link">
									<b-link class="info_popup_link" :id="'disclaimerLink'" aria-label="disclaimer">
										<span class="lnk_txt">disclaimer</span>
										<span class="exclamation-circle"><span class="fas fa-exclamation-circle"></span></span>
									</b-link>
								</div>
								<div id="disclaimerPopup" class="info_popup">
							  		<b-popover
							  			:target="'disclaimerLink'"
										triggers="hover focus"
										container="disclaimerPopupr">
											<div class="info_popup_content">
												Please contact your advisor for the exact program requirements and additional clarifications
											</div>
							  		</b-popover>
								</div>

							</div>
							<div class="card-body">
								<div class="credit-completion-pie-chart">

                  					<template v-for="(pg, index) in stream.programGuides" v-if="pg.progress.courseValues.length > 0">

                    					<div class="pie-chart-container ace_sec_txt" :aria-label="pg.title">
                    						<div class="chart_top_layer" :id="'piechartLayer_' + index"></div>
                    						<div class="pie_chart" :id="'piechart_' + index" @click="openProgresspopup(index), activateChartTopLayer(index)"></div>
                    						<div>
											  <span class="title_new" :title="pg.title">
                                                  <v-clamp class="title_txt" autoresize :max-lines="2" v-html="pg.title"></v-clamp>
                                              </span>
											</div>
                    					</div>


                    						<b-popover :ref="'progressPopup_'+index" :target="'piechart_'+index" :show.sync="popoverShow" container="creditProgressPopup">
    											<template slot="title">
		    										<div class="header-title">
		    											<span class="icon icon-stream"></span>
		    											<span class="entity-title ace_sec_hd" v-html="pg.title"></span>
		    											 <button class="btn_close" aria-label="close" @click="closeProgresspopup(index), deactivateChartTopLayer(index)">
                                                            <span class="ic-close"></span>
                                                         </button>
		    										</div>
    											</template>


    											<div class="entity-cont-section">
    												<div class="category-expanded-section">
    													<div class="tree-category-row" v-for="category in pg.categories">
    														<div class="right-column">
    															<div class="title-row">
    																<span class="icon icon-stream"></span>
    																<span class="title-name ace_sec_txt">{{category.title}}</span>
    															</div>
    															<div class="cont-row">
    																Courses - Required <span tabindex="0">{{category.minimumCourses}}</span> / Taken <span class="ace_sec_txt">{{category.coursesUsed}}</span> / Needed <span class="ace_sec_txt">{{calculateNeed(category.coursesNotPlanned, category.minimumCourses, category.coursesUsed)}}</span>
    															</div>
    														</div>
    													</div>
    												</div>
													<div class="more-container">
														<b-link :to="{ name: 'streamCategory', params: { uuid: uuid } }">show more</b-link>
													</div>
    											</div>
    										</b-popover>

                  						</template>
									</div>
								</div>
							</div>
					  </div>
					  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 degress-progress-section" v-if="showDegreeProgress">
						<div class="card ace_sec" aria-label="Degree Progress Section">
							<div class="card-header">
								<span class="icon icon-progress"></span>
								<span class="label ace_sec_hd" role="heading" aria-label="Degree Progress">Degree Progress</span>
							</div>
							<div class="card-body">
                				<div class="head-row major ace_sec_txt" :aria-label="'Advisor ' + advisorName" v-if="advisorName">
									<span class="heading-label">Advisor:</span> <span class="data-desc advisor-name" :title="advisorName"> {{advisorName}}</span>
								</div>
								<div class="head-row major ace_sec_txt" v-if="major" :aria-label="'Major ' + major" >
									<span class="heading-label">Major:</span> <span class="data-desc" :title="major"> {{major}}</span>
								</div>
								<div class="head-row center_row ace_sec_txt" :aria-label="'Major GPA ' + majorGPA">
								<span class="heading-label">Major GPA:</span> <span class="data-desc" :title="majorGPA">{{majorGPA}}</span>
								</div>
								<div class="head-row center_row ace_sec_txt" :aria-label="'Overall GPA ' + overallGPA">
								<span class="heading-label">Overall GPA:</span> <span class="data-desc" :title="overallGPA">{{overallGPA}}</span>
								</div>
							</div>
						</div>
					  </div>
					</div>

					<div class="row dashboard-row competency-progress" style="margin-top: 0px;">
						<div class="col-12">
							<div class="card ace_sec" aria-label="Course Progress Section">
								<div class="card-header">
									<span class="icon icon-activity"></span>
									<span class="label ace_sec_txt" role="heading" aria-label="Course Progress">Course Progress</span>
								</div>
								<div class="card-body">
									<div class="plo_block_container">
										<div class="block transferred" :class="{'block_with_excluded': isShowExcludedCourses}">
											<div class="heading ace_sec_txt" aria-label="Transferred">Transferred</div>
											<div class="block_values">
												<div class="plo ace_sec_txt" :aria-label="t.code" v-for="t in transferredCourses" :title="t.title">{{t.code}}</div>
											</div>
										</div>

										<div class="block completed" :class="{'block_with_excluded': isShowExcludedCourses}">
											<div class="heading ace_sec_txt" aria-label="Completed">Completed</div>
											<div class="block_values">
												<div class="plo ace_sec_txt" :aria-label="c.code" v-for="c in completedCourses" :title="c.title">{{c.code}}</div>
											</div>
										</div>

										<div class="block in_progress" :class="{'block_with_excluded': isShowExcludedCourses}">
											<div class="heading ace_sec_txt" aria-label="In Progress">In Progress</div>
											<div class="block_values">
												<div class="plo ace_sec_txt" :aria-label="i.code" v-for="i in inprogressCourses" :title="i.title">{{i.code}}</div>
                                                <div class="plo ace_sec_txt" :aria-label="g.code" v-for="g in gradePendingCourses" :title="g.title">{{g.code}}*</div>
                                                <div class="plo ace_sec_txt" :aria-label="inc.code" v-for="inc in incompleteCourses" :title="inc.title">{{inc.code}}**</div>
											</div>
										</div>

										<div class="block scheduled" :class="{'block_with_excluded': isShowExcludedCourses}">
											<div class="heading ace_sec_txt" aria-label="Scheduled">Scheduled</div>
											<div class="block_values">
												<div class="plo ace_sec_txt" :aria-label="s.code" v-for="s in scheduledCourses" :title="s.title">{{s.code}}</div>
											</div>
										</div>

										<template v-if="isShowExcludedCourses">
    										<div class="block excluded">
    											<div class="heading ace_sec_txt excluded_heading" :aria-label="excludedCoursesLabel">{{excludedCoursesLabel}}</div>
    											<div class="block_values">
    												<div class="plo ace_sec_txt" :aria-label="s.code" v-for="s in excludedCourses" :title="s.title">{{s.code}}</div>
    											</div>
    										</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
      <div class="col-11 dasboard-left-section" v-if="!isProgramGuideAvailable && !showLoader">
        <div class="course-description col-12">
          <b-jumbotron>
            <h4 class="text-center ace_sec_txt" aria-label="Progress View is currently not available">Progress View is currently not available.</h4>
            <p class="text-center ace_sec_txt" aria-label="Please reach out to your institutional admin to unlock the Progress View">Please reach out to your institutional admin to unlock the Progress View.</p>
          </b-jumbotron>
        </div>
      </div>
     </div>

     <!--
     <div class="loader" v-if="showLoader"></div>
     -->

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StreamMenu from './StreamMenu'
import StreamHeader from './StreamHeader'
import { PACKAGE } from '../../../package_constants'
import * as d3 from 'd3'
import VClamp from 'vue-clamp'

export default {
  name: 'streamProgress',
  props: ['uuid'],
  components: {
    StreamMenu,
    StreamHeader,
    VClamp
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      showLoader: false
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadUserAdvisor',
      'loadCategory',
      'loadLogDashboardActivity'
    ]),

    loadStream () {
      // DO NOT COMMENT OUT SHOW LOADER. This is used for other purposes too.
      this.showLoader = true
      this.$refs.loadingModal.show()
      this.loadLogDashboardActivity({action: 'viewStreamProgressView', page: 'streamProgressView', link: '', entityUuid: this.uuid})
      this.loadStreamDetail(this.uuid).then(res => {
        this.loadUserAdvisor(this.stream.ownerId)
        if (this.stream.programGuides) {
          let showCreditProgress = this.isShowCreditProgressEnabled
          let showCourseProgress = this.isShowCourseProgressEnabled
          let showCourseProgressOnOverall = this.isShowCourseProgressOnOverallEnabled
          for (var i = 0; i < this.stream.programGuides.length; i++) {
            if (this.stream.programGuides[i].title === 'Overall' && (!showCourseProgressOnOverall || showCreditProgress)) {
              this.generatePieChart(this.stream.programGuides[i].progress.values, 'piechart_' + i)
              this.stream.programGuides[i].title = 'Overall <strong>' + this.creditLabel + 's</strong>'
            } else if (showCourseProgress) {
              this.stream.programGuides[i].title = this.stream.programGuides[i].title + ' <strong>Courses</strong>'
              this.generatePieChart(this.stream.programGuides[i].progress.courseValues, 'piechart_' + i)
            } else {
              this.generatePieChart(this.stream.programGuides[i].progress.values, 'piechart_' + i)
            }
          }
        }
        this.showLoader = false
        this.$refs.loadingModal.hide()
      })
    },

    calculateNeed (coursesNotPlanned, min, used) {
      if (coursesNotPlanned > -1 && (min > used)) {
        return min - used
      } else {
        return 0
      }
    },

    changeCategory (category) {
    },

    activateChartTopLayer (chartIndex) {
      $('.chart_top_layer').removeClass('activate_chart_layer')
      $('#piechartLayer_' + chartIndex).addClass('activate_chart_layer')
    },

    deactivateChartTopLayer (chartIndex) {
      $('#piechartLayer_' + chartIndex).removeClass('activate_chart_layer')
    },

    openProgresspopup (index) {
      for (var i = 0; i < this.stream.programGuides.length; i++) {
        let progressPopupId = 'progressPopup_' + i
        this.$refs[progressPopupId][0].$emit('close')
      }

      let refer = 'progressPopup_' + index
      this.$refs[refer][0].$emit('open')
    },

    closeProgresspopup (index) {
      let refer = 'progressPopup_' + index
      this.$refs[refer][0].$emit('close')
    },

    getLabel (label) {
      if (label.indexOf('credits') !== -1) {
        return label.replace('credit', this.creditLabel.toLowerCase())
      }
      return label
    },

    generatePieChart (data, elementId) {
      // var pieChartContainerWidth = $(".pie_chart_container").innerWidth()
      // var pieChartContainerHeight = $(".pie_chart_container").innerHeight()
      var pieChartContainerHeight = 162
      var pieChartInnerRadius = 35
      var width = pieChartContainerHeight
      var height = pieChartContainerHeight
      var radius = pieChartContainerHeight / 2

      // var colors = ['#f0b13c', '#ff9326', '#18b8ed', '#4b9036', '#a0cb59', '#990099', '#3366cc', '#dc3912', '#ff9900', '#109618',
      //  '#6969ff', '#ffff69', '#b0c4de', '#008b8b', '#cdb075', '#0066cc', '#a4d47d', '#b0c4de', '#9acd32', '#4684ed'],

      var colorScale = {
        // credit progress
        /*
        'transferred': '#aac76b',
        'completed': '#5c8c43',
        'in progress': '#56b5e8',
        'scheduled': '#f09546',
        'credits needed': '#e6b055',
        'not in plan': '#969696',
        'in the plan': '#1eb1eb',
        */
        // course progress
        // 'transferred courses': '#aac76b',
        // 'completed courses': '#5c8c43',
        // 'in progress courses': '#56b5e8',
        // 'scheduled courses' : '#f09546',
        // 'courses needed': '#e6b055',
        // 'not in plan': '#969696',
        // 'in the plan': '#1eb1eb'

        'transferred': '#56b5e8',
        'completed': '#508102',
        'in progress': '#9fc958',
        'scheduled': '#f5b318',
        'credits needed': '#cf7908',
        'not in plan': '#969696',
        'in the plan': '#1eb1eb',

        'transferred courses': '#56b5e8',
        'completed courses': '#508102',
        'in progress courses': '#9fc958',
        'scheduled courses': '#f5b318',
        'courses needed': '#cf7908'
      }

      var tooltip = d3.select('body')
                    .append('div')
                    .style('position', 'absolute')
                    .style('z-index', '10')
                    .style('visibility', 'hidden')
                    .style('color', '#111')
                    .attr('class', 'report-tooltip-xaxis')
                    .style('padding', '8px')
                    .style('border-radius', '6px')
                    .style('font', 'bold 15px Arial')
                    .text('tooltip')

      var canvas = d3.select('#' + elementId).append('svg')
                   .data([data]).attr('width', width).attr('height', height).append('g')
                   .attr('transform', 'translate(' + radius + ',' + radius + ')')

      var arc = d3.arc()
                .outerRadius(radius)
                .innerRadius(pieChartInnerRadius)

      // var labelArc = d3.arc()
                     // .outerRadius(radius - 75)
                     // .innerRadius(radius - 55)

      var pie = d3.pie()
                .value(function (d) { return d.value }).sort(null)

      var arcs = canvas.selectAll('.arc')
                 .data(pie(data))
                 .enter().append('g')
                 .attr('class', 'arc')

      arcs.append('path')
          .attr('d', arc)
          .style('fill', (d, i) => { return colorScale[d.data.label] })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', function () {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', function () {
            return tooltip.style('visibility', 'hidden')
          })

      arcs.append('text')
          .attr('transform', (d) => { return 'translate(' + arc.centroid(d) + ')' })
          .style('font', 'bold 12px Arial')
          .style('fill', '#fff')
          .style('cursor', 'default')
          .attr('text-anchor', 'middle')
          .text((d) => { return d.data.value })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', () => {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', () => {
            return tooltip.style('visibility', 'hidden')
          })
    }

  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'advisor': state => state.user.advisor,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    major () {
      if (this.uObj && this.uObj.major1Title) {
        return this.uObj.major1Title
      }
      return ''
    },
    majorGPA () {
      if (this.stream.majorGPA) {
        return this.stream.majorGPA
      } else {
        return ''
      }
    },
    overallGPA () {
      if (this.stream.overallGPA) {
        return this.stream.overallGPA
      } else {
        return ''
      }
    },
    progressView () {
      if (this.stream.progressViewStructure) {
        return JSON.parse(this.stream.progressViewStructure)
      } else {
        return {}
      }
    },
    isProgramGuideAvailable () {
      if (this.stream && this.stream.programGuides && this.stream.programGuides.length > 1) {
        return true
      } else {
        return false
      }
    },
    transferredCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.transferred
      } else {
        return []
      }
    },
    completedCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.completed
      } else {
        return []
      }
    },
    inprogressCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.inprogress
      } else {
        return []
      }
    },
    gradePendingCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.gradePending
      } else {
        return []
      }
    },
    incompleteCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.incomplete
      } else {
        return []
      }
    },
    scheduledCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.scheduled
      } else {
        return []
      }
    },
    excludedCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.excluded
      } else {
        return []
      }
    },
    advisorName () {
      if (this.advisor) {
        return this.advisor.name
      } else {
        return null
      }
    },
    advisorTitle () {
      if (this.userrole === 'Advisor' && this.stream && this.stream.ownerName) {
        return '' + this.stream.ownerName + ''
      } else {
        return ''
      }
    },
    isExcludedCoursesEnabled () {
      let excludedCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXCLUDED_COURSES_FEATURE_ID]
      if (excludedCoursesFeature) {
        return excludedCoursesFeature.enabled
      }
      return false
    },
    isShowExcludedCourses () {
      return (this.isExcludedCoursesEnabled && this.excludedCourses.length > 0)
    },
    excludedCoursesLabel () {
      let label = 'Excluded'
      let excludedCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXCLUDED_COURSES_FEATURE_ID]
      if (excludedCoursesFeature) {
        label = excludedCoursesFeature.label
      }
      return label
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCourseProgressOnOverallEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    showDegreeProgress () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showDegreeProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
    .excluded {
        width: calc(20% - 1px);
        background-color: #969696;
    }

    .excluded_heading {
        background-color: #7b7b7b;
    }

    .block_with_excluded {
        width: calc(20% - 1px);
    }
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamProgress.vue